<template>
    <div class="article scrollstyle">
        <span class="article-title">
            {{ article.title }}
        </span>
        <div class="article-time">
            <div>
                {{ article.crtTime }}
                <span>{{ articleType }}</span>
            </div>
            <div>
                <svg-icon class="icon" icon="share" @click="shareBtn()"/>
            </div>
        </div>
        <div class="article-cont" v-html="article.html"></div>
    </div>
</template>
<script>
// import {ref} from 'vue'
import { useRoute } from 'vue-router'
import { useStore } from "vuex"
import { useI18n } from "vue-i18n"
export default {
    setup() {
        const i18n = useI18n();
        const { t } = i18n;
        const route = useRoute()
        const store = useStore()
        let lang = route.params.lang
        if(lang == 'jp') lang = 'en' // 日文先預設抓英文資訊(等官網好了再改)

        let id = route.params.id
        let type = route.params.type
        const article = store.state.os[type][lang].data.filter((item)=>{
            return item.id == id
        })[0]
        
        // 取得官網訊指定的內容
        store.dispatch('getOSHTMLByID', {lang: lang, id: id, type: type})

        let articleType = ''
        switch(type) {
            case 'news':
                articleType = t("EducationNews")
            break;
            case 'academic':
                articleType = t("AcademicPapers")
            break;
            case 'event':
                articleType = t("EventsSection")
            break;
        }

        async function shareBtn() {
            store.dispatch('shereArticleUrl', {lang: lang, id: id, type: type})
        }

        return {
            shareBtn,
            article,
            articleType
        }
    },
}
</script>